// theirs
import styled, { createGlobalStyle } from 'styled-components'
// ours
import { typography } from '../styles'

const globalStyle = createGlobalStyle`
    *{
        margin: 0;
        padding: 0;
        outline:0;
        box-sizing:border-box;
    }
    
    #root{
        margin:0 auto;
        overflow: hidden;
        height: 100vh;
    }

    body {
        font-size: ${typography.size.root};
        font-family: ${typography.type.primary};
        margin: 0;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    h1, h2, h3, h4, h5, h6 {
        font-family: ${typography.type.secondary};
        overflow-wrap : normal;
    }
    img {
        max-width: initial;
        height: initial;
    }
`
export default globalStyle

export const GlobalStyleScrollHorizontally = styled.div`
    display: flex;
    flex-direction: row;
    overflow: auto;
`

export const GlobalStyleScrollVertically = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
`
